import { IFormatter } from '../FormatterTypes';
import { TEDDisplayBool } from '../Displayers/TEDDisplayBool';
import { TEDValidateDefault } from '../Validators/TEDValidateDefault';
import { TEDParseBool } from '../Parsers/TEDParseBool';

// TODO: Implement parser / validator. Test functionality of displayer
class TEDFormatBool implements IFormatter {
  displayer = TEDDisplayBool.getInstance();

  parser = TEDParseBool.getInstance();

  validator = TEDValidateDefault.getInstance();
}

export { TEDFormatBool };
